<template>
  <div>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Perusahaan'"
      :valueData="data.company_name"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Usaha'"
      :valueData="data.owner_name"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor Rekening Perusahaan'"
      :valueData="data.account_number"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor KTP Pemilik Usaha'"
      :valueData="data.ktp_no"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor NPWP Perusahaan'"
      :valueData="data.npwp_no"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor Telepon'"
      :valueData="merchantPhone == ' ' ? '( not set )' : merchantPhone"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email'"
      :valueData="data.email"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Alamat Perusahaan'"
      :valueData="data.address"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kota, Kecamatan, Kode Pos'"
      :valueData="
        data.kabupaten_kota + ', ' + data.kecamatan + ', ' + data.kode_pos
      "
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'KODE BC/KO'"
      :valueData="text(data.bcko)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Merchant Category Segment'"
      :valueData="text(data.cmer)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Referral Code'"
      :valueData="text(data.referral_code)"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'ID Approver 1'"
      :valueData="data.approver_1"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'ID Approver 2'"
      :valueData="data.approver_2"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Additional Data</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tempat Lahir Pemilik Usaha'"
      :valueData="text(data.owner_city_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tanggal Lahir Pemilik Usaha'"
      :valueData="text(data.owner_date_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Alamat Pemilik Usaha'"
      :valueData="text(data.owner_address)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kode Pos Pemilik Usaha'"
      :valueData="text(data.owner_postal_code)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Rekening'"
      :valueData="text(data.account_holder_name)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kantor Cabang Terdekat'"
      :valueData="text(data.bni_branch_office)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tahun Berdiri'"
      :valueData="text(data.merchant_est_since)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email Merchant'"
      :valueData="text(data.merchant_email)"
    />

    <div v-if="data.image_ktp">
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Dokumen</h3>
        </div>
      </v-card>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto TTD </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_tanda_tangan" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Lokasi Usaha </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_lokasi" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NPWP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_npwp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NIB </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <app-pdf-viewer
              :id="$route.params.id"
              :pdfData="data.image_nib"
              pdfType="pdfNibView"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-card
      class="mb-12"
      height="20px"
      :style="{
        'box-shadow': '0 0 black',
        'margin-top': '20px',
      }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Endpoint</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'URL'"
      :valueData="text(data.endpoint)"
    />

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'IP Address'"
      :valueData="text(data.ip_address)"
    />
    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Keterangan</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Status'"
      :valueData="data.status"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Last Update'"
      :valueData="data.updated_at"
    />
    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      v-if="data != null && data.remark != null"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Remarks</h3>
      </div>
    </v-card>
    <v-card
      v-if="data != null && data.remark != null"
      :style="{ 'box-shadow': '0 0 black' }"
    >
      <remark-row :data="data" />
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-btn
          small
          color="orange"
          dark
          :style="{ margin: '2px' }"
          @click="back"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { text } from '../../lib/helpers';

export default {
  components: {
    DataDetailRow: () => import('./DataDetailRow.vue'),
    RemarkRow: () => import('./RemarkRow.vue'),
    AppPdfViewer: () => import('../form/AppPdfViewer.vue'),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
  },
  methods: {
    text,

    back() {
      this.$router.back();
    },
  },
};
</script>
